import { addLastPrefixFR } from '../transforms/addLastPrefix';
import { capitalizeFirstLetter } from '../transforms/capitalizeFirstLetter';
import { formatShortMonthFRCA } from '../transforms/formatShortMonth';
import { removeDots } from '../transforms/removeDots';
import { uppercase } from '../transforms/uppercase';
import { overrideBaseLocale } from './base-config';
export var frCA = overrideBaseLocale('fr-CA', {
    dayOfWeekShort: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots],
    },
    dayOfWeekShortUppercase: {
        options: {
            weekday: 'short',
        },
        transforms: [uppercase, removeDots],
    },
    dayOfWeekLongPropercase: {
        options: {
            weekday: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
        transforms: [capitalizeFirstLetter, removeDots],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixFR, capitalizeFirstLetter],
    },
    monthShort: {
        options: {
            month: 'short',
        },
        transforms: [removeDots, formatShortMonthFRCA],
    },
    monthShortUppercase: {
        options: {
            month: 'short',
        },
        transforms: [uppercase, removeDots, formatShortMonthFRCA],
    },
    monthLongPropercase: {
        options: {
            month: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter, removeDots, formatShortMonthFRCA],
    },
});
//# sourceMappingURL=fr-CA.js.map